// extracted by mini-css-extract-plugin
export default {"cls1":"OverlappingAvatars-cls1_dNw","cls2":"OverlappingAvatars-cls2_dEt OverlappingAvatars-cls1_dNw"};